import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '@/shared/ui/button'
import { Home, ArrowLeft } from 'lucide-react'

export function NotFoundPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="text-center max-w-md">
        <p className="text-7xl font-bold text-muted-foreground/30 mb-2">{t('auth2:notFound.code')}</p>
        <h1 className="text-2xl font-semibold mb-2">{t('auth2:notFound.title')}</h1>
        <p className="text-muted-foreground mb-8">
          {t('auth2:notFound.body')}
        </p>
        <div className="flex items-center justify-center gap-3">
          <Button variant="outline" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            {t('auth2:notFound.goBack')}
          </Button>
          <Button onClick={() => navigate('/dashboard')}>
            <Home className="h-4 w-4 mr-2" />
            {t('auth2:notFound.dashboard')}
          </Button>
        </div>
      </div>
    </div>
  )
}
